<template>
  <div id="SpectrumFAQs" class="container-fluid px-0">
    <div class="main">
      <div class="page-header">
        <div class="page-title d-flex flex-column align-items-center">
          <img class="logo" src="/img/spectrum_life_logo_light.png" />
          <h2 class="brand-text mb-0">FAQs</h2>
        </div>
      </div>
      <div class="content">
        <div class="content-card">
          <ol class="top-list">
            <li><a href="#coaching-bundle">Coaching Bundle FAQs</a></li>
            <li><a href="#single-session">Single Session FAQs</a></li>
            <li>
              <a href="#neurodiversity-service">Neurodiversity Service FAQs</a>
            </li>
            <li>
              <a href="#digital-therapy">Open-ended Digital Therapy Service FAQs</a>
            </li>
          </ol>
          <h3 id="coaching-service">1. Coaching Bundle FAQs</h3>

          <h4>
            What coaching services are sold in Bundles?
          </h4>
          <p>The mental health and sleep coaching sessions are sold in bundles of 3, so you will get 3 coaching sessions.</p>

          <h4>What is the mental health coaching service?</h4>
          <p>
            This service is available to policy holders and dependants named on
            the plan, aged 18 and over. It will guide you in taking action to
            overcome life’s challenges, from managing your stress to building
            better coping strategies. Discover expert-led sessions with a mental
            health coach, designed to support you. The coaching sessions focus
            on the present, helping you to set meaningful goals and offering
            personalised guidance to help you feel more balanced and in control.
          </p>
          <p>
            From a safe and collaborative space, you will explore your
            challenges and work on improving your wellbeing. This package will
            provide you with three coaching sessions, which will introduce you
            to your mental health coach who will help you get onto the right
            path and identify achievable goals for you to work towards. You will
            also get access to a personalised coaching area to chat with your
            coach and track your goals throughout your programme.
          </p>

          <h4>What is the sleep coaching service?</h4>
          <p>
            From improving your nightly rest to breaking bad bedtime habits,
            discover expert-led sessions tailored to help better your sleep.
            This service is available to policy holders and dependants named on
            the plan aged 18 and over, and it provides you with three coaching
            sessions to help you start tracking your sleep. It will introduce
            the concepts around sleep hygiene and explore factors that might be
            disrupting your rest.
          </p>
          <p>
            Once you’ve bought your coaching sessions, via our partner
            Spectrum.life, you’ll have access to the Coaching Area. In here, you
            will find a two-way chat functionality, enabling you to keep in
            touch with your coach outside of the coaching sessions. You can also
            use this area to arrange your subsequent sessions (although you can
            do this during your first coaching session). This area is also where
            you’ll find your goals, achievements and anything that has been
            tracked since your first appointment.
          </p>

          <h4>
            What topics are covered under the mental health and sleep coaching
            sessions?
          </h4>
          <p>
            The mental health coaching sessions offer guidance and support on a
            range of topics and issues including:
          </p>
          <ul>
            <li>Improving Social Confidence</li>
            <li>Mindset for Health & Fitness</li>
            <li>Mindful Living</li>
            <li>Boosting Mood</li>
            <li>Managing Worry</li>
            <li>Improving Relationships</li>
            <li>Overcoming Burnout at Work</li>
            <li>Coping with Chronic Pain</li>
            <li>Coping with Health Issues</li>
            <li>Understanding Grief</li>
            <li>Understanding Myself</li>
          </ul>
          <p>
            The sleep coaching sessions include a variety of different topics
            depending on your goals including:
          </p>
          <ul>
            <li>Breaking bad bedtime habits</li>
            <li>Improving your nightly rest</li>
            <li>Sleep Hygiene</li>
            <li>Sleep Tracking</li>
            <li>Sleep for Boosting Mood and Productivity</li>
          </ul>

          <h4>How do I buy the coaching sessions?</h4>
          <p>
            You can book your consultation directly through the Simplyhealth
            app, SimplyPlan, from the ‘Mental Health’ or ‘Wellbeing’ category
            within ‘My Health’. Just fill out the details about yourself,
            thenselect a time and date that suits you for your appointment. You
            will then be prompted to make a payment when you proceed to book the
            consultation directly with Spectrum.life.
          </p>

          <h4>
            How long are each of the mental health and sleep coaching sessions?
          </h4>
          <p>
            The first coaching session is 45 minutes long, with the second and
            third sessions being 30 minutes in length.
          </p>

          <h4>How much does the bundle of 3 coaching sessions cost?</h4>
          <p>It costs £189 for the bundle of 3 coaching sessions.</p>

          <h4>How do I book in my second and third coaching sessions?</h4>
          <p>
            Once you’ve purchased your bundle of coaching sessions, you’ll have
            access to the Coaching Area. In here, you’ll find a two-way chat
            functionality that will enable you to stay in touch with your coach,
            outside of the coaching sessions. You can arrange any subsequent
            sessions through the chat function.
          </p>

          <h4>
            Will I have the same coach throughout all 3 sessions of my journey?
          </h4>
          <p>
            Yes, your coach won’t change as you complete your mental health and
            sleep coaching journeys.
          </p>

          <h4>What are the qualifications of the coaches?</h4>
          <p>
            All mental health and sleep coaching services are delivered by a
            mental health coach, with the following qualifications:
          </p>
          <ul>
            <li>
              Bachelor's degree in a relevant field such as psychology or mental
              health or positive parenting.
            </li>
            <li>
              Completion of a Postgraduate Certificate (PGCert) in Low-Intensity
              Interventions or a similar training programme or a coaching
              programme.
            </li>
            <li>Enhanced Disclosure and Barring Service (DBS)</li>
          </ul>

          <h4>
            How do I access the mental health and sleep coaching sessions?
          </h4>
          <p>
            You can join your consultation by logging into the Simplyhealth app
            and navigating to ‘My Health’, where you’ll see the appointment
            listed. Then, just click ‘join’ to begin the session at the
            confirmed appointment time.
          </p>

          <h4>How do I access the chat function with my coach?</h4>
          <p>
            The chat functionality with your coach is accessed in the Coaching
            Dashboard area of the Simplyhealth app. From here, you can also see
            your goals, achievements, and impact that have been tracked since
            your first appointment.
          </p>

          <h4>
            What is the minimum age for users accessing the Coaching Services?
          </h4>
          <p>
            Mental Health and Sleep Coaching Services are available for adults
            only, aged 18 and up.
          </p>

          <h4>
            In what circumstances is Mental Health Coaching not an appropriate
            service to access?
          </h4>
          <p>
            Mental Health Coaching is designed for mild to moderate levels of
            distress on a wide range of issues. The coaching sessions are best
            suited for individuals looking for practical, proactive support in
            managing stress, developing healthy habits and setting personal
            goals in a sub-clinical context, however, there are some exclusions:
          </p>
          <ul>
            <li>
              Mental Health Coaching is only suitable for adults ages 18 and up.
            </li>
            <li>
              Coaching is not appropriate for individuals currently dealing with
              severe or complex mental health diagnoses that require a clinical
              level of care.
            </li>
            <li>
              Coaching is not a replacement for psychological
              counselling/therapy or psychiatric treatment.
            </li>
            <li>
              Coaching does not provide crisis intervention or emergency
              support. Those in immediate distress or facing urgent mental
              health difficulties should contact emergency services for prompt
              assistance. Coaching services are not a replacement for crisis
              support or a GP.
            </li>
            <li>
              For individuals experience substance dependence or addiction,
              specialised addiction support or treatment programmes would be
              better suited to support these types of difficulties.
            </li>
            <li>
              For immediate help and support, our 24/7 Mental Health support
              service would be better suited to your needs.
            </li>
          </ul>
          <h4>
            In what circumstances is Sleep Coaching not an appropriate service
            to access?
          </h4>
          <p>
            Sleep coaching is designed to support mild to moderate sleep
            challenges, when you’re looking for non-clinical support or are
            looking to build healthier sleep habits. Sleep coaching is not
            suitable if you are:
          </p>
          <ul>
            <li>
              Struggling with a clinical sleep disorder: For conditions like
              insomnia or sleep apnoea, a medical professional would be more
              suitable.
            </li>
            <li>
              Immediate or crisis support is needed: for urgent situations, the
              in-the-moment support or a GP may be more a more suitable
              resource.
            </li>
            <li>
              Seeking therapy for underlying issues: if emotional or
              psychological issues affect sleep, open-ended therapy to address
              underlying concerns may be more appropriate.
            </li>
          </ul>

          <h4>When are coaching sessions available?</h4>
          <p>
            Coaching sessions are available Monday-Friday, 9am-5pm, excluding
            Public Holidays and Bank Holidays.
          </p>

          <h4>
            What are the possible next steps when I finish my coaching journey?
          </h4>
          <p>
            Each coaching journey is different, so are the next steps, following
            your 3-session journey. Some people will engage in another bundle of
            3 coaching sessions, others will engage in other mental health/
            clinical services, for some, their journey will be complete once
            they’ve finished the third coaching session, others might engage a
            GP through the NHS or their private insurer.
          </p>

          <h3 id="single-session">2. Single Session FAQs</h3>

          <h4>
            What services are covered in the single session consultations?
          </h4>
          <p>
            Single Session Consultations are available across a variety of
            topics:
          </p>
          <ul>
            <li>Parenting</li>
            <li>Menopause</li>
            <li>Gut Health & Healthy Diet</li>
            <li>Weight Management</li>
          </ul>
          <h4>How long is a consultation in any of the above topics?</h4>
          <p>Each consultation is 30 minutes long.</p>

          <h4>How much does a consultation cost?</h4>
          <p>
            A single session consultation has a different cost per consultation
            type. If you are looking for a parenting consultation, the fee is
            £65, for a menopause consultation, the fee is £59, the gut health &
            healthy diet and weight management consultation fees are £49.
          </p>

          <h4>
            Is there a way to contact the coach who carried out the
            consultation, post consultation?
          </h4>
          <p>
            No. There is no live chat functionality within the consultation
            service. You can book additional consultations (for an additional
            fee per session), if you’d like to have more sessions.
          </p>

          <h4>How do I book and pay for the consultations?</h4>
          <p>
            You can book your consultation directly through the Simplyhealth App
            or portal, in the My Health area. You will need to fill out some
            personal details about yourself before selecting a time and date
            that suits you for your appointment. You will then be prompted to
            make payment for the consultation when you are booking the session.
          </p>

          <h4>Will I receive any confirmation or reminders of my booking?</h4>
          <p>
            Yes, you will receive a confirmation email from Spectrum.life once
            your appointment is confirmed. You will also receive a reminder
            email 48 hours before your appointment.
          </p>

          <h4>How do I join the consultation session?</h4>
          <p>
            You can join the consultation session by logging into the
            Simplyhealth App or portal, and navigating to the ‘My Health’ area,
            here you should see the appointment listed, and you can click ‘join’
            to join the session at the appointment time.
          </p>

          <h4>Who will my parenting coaching be with?</h4>
          <p>
            All parenting consultations are carried out by a qualified mental
            health coach, with the following credentials:
          </p>
          <ul>
            <li>
              Bachelor's degree in a relevant field such as psychology or mental
              health or positive parenting.
            </li>
            <li>
              Completion of a Postgraduate Certificate (PGCert) in Low-Intensity
              Interventions or a similar training programme or a coaching
              programme.
            </li>
            <li>Enhanced Disclosure and Barring Service (DBS).</li>
          </ul>

          <h4>How are the Parenting Coaching Consultations designed?</h4>
          <p>
            The parenting consultations are designed by our Clinical Lead, who
            is an expert in children and young people and is a clinical
            psychologist in this field. Our Clinical Lead not only develops
            these structured coaching journeys but also provides ongoing
            training and supervision to our mental health coaches, ensuring that
            each session is aligned with best practices in supporting parents.
          </p>

          <h4>
            When are the single session consultations appropriate for Parenting?
          </h4>
          <p>
            Single session parent coaching consultations are ideal for brief,
            solution-focused support to help parents navigate immediate concerns
            or common parenting challenges. Some situations in which this may be
            useful include:
          </p>
          <ul>
            <li>Looking for guidance on specific parenting challenges</li>
            <li>Looking for practical tips</li>
            <li>Support to address a recent challenge</li>
            <li>Signposting & resources</li>
          </ul>

          <h4>
            When are the single session consultations not appropriate for
            Parenting?
          </h4>
          <p>
            The single session parenting consultations are not suitable if you
            are:
          </p>
          <ul>
            <li>Looking for longer term support</li>
            <li>Managing complex family dynamics</li>
            <li>Experiencing Family Crisis</li>
          </ul>

          <h4>Who will my menopause consultation be with?</h4>
          <p>
            All menopause consultations are carried out by an Advanced Nurse
            Practitioner (ANP), with the following credentials:
          </p>
          <ul>
            <li>
              Registered General Nurse with the Nursing and Midwifery Council
              (NMC).
            </li>
            <li>
              PgDip/MSc or RCN accredited Advanced Nurse Practitioner (ANP).
            </li>
            <li>Experience in Remote working and digital consultations</li>
            <li>
              Minimum 2 years post-qualification professional experience in
              Primary Care.
            </li>
            <li>Enhanced Disclosure and Barring Service (DBS)</li>
          </ul>

          <h4>
            When are the single session consultations appropriate for Menopause?
          </h4>
          <p>
            This is a coaching service designed to support women in managing
            their menopause. Carried out by ANP’s with specialist knowledge in
            women’s health, they are there for you to help you manage your
            symptoms, empower you through this natural progression, and guide
            you through some of your concerns. This is a coaching service, so if
            you are looking to initiate on treatment, please speak to one of our
            women’s health GPs via our Nurse and GP service.
          </p>

          <h4>
            When are the single session consultations not appropriate for
            Menopause?
          </h4>
          <p>The service is not appropriate for:</p>
          <ul>
            <li>Unmanaged Severe Menopausal Symptoms</li>
            <li>Untreated Mental Health Conditions</li>
            <li>Unexplained abnormal Post-Menopausal Bleeding</li>
            <li>Desire for Medication or Referral</li>
          </ul>

          <h4>
            Who will my Gut Health & Healthy Diet, or Weight Management
            consultation be with?
          </h4>
          <p>
            All gut health & healthy diet, and weight management consultations
            are carried out by a dietitian , with the following credentials:
          </p>
          <ul>
            <li>Dietitian:</li>
            <ul>
              <li>
                Registered as a Dietitian with the Health & Care Professions
                Council (HCPC).
              </li>
              <li>Member of the British Dietetics Association (BDA).</li>
              <li>
                Minimum 3 years post-qualification professional experience.
              </li>
              <li>
                Minimum 2 years post-qualification experience in Gut Health and
                Weight Management.
              </li>
              <li>Enhanced Disclosure and Barring Service (DBS)</li>
            </ul>
          </ul>

          <h4>
            When are the single session consultations appropriate for Gut Health
            & Healthy Diet or Weight Management?
          </h4>
          <p>
            Dietitian/ Nutritionist sessions are focused on holistic care, these
            services often integrate medical, nutritional, and psychological
            support, ensuring a comprehensive strategy for weight-related goals.
            The emphasis on sustainable lifestyle changes, rather than quick
            fixes, builds long-term success and promotes overall well-being.
            Additionally, regulatory standards ensure high-quality care, backed
            by qualified practitioners and up-to-date research. The personalised
            attention and focus on health, rather than just numbers on a scale,
            make these services stand out as a trusted choice.
          </p>

          <h4>
            Who can access the single session consultations for Gut Health &
            Healthy Diet or Weight Management?
          </h4>
          <p>
            The single session consultations for Gut Health & Healthy Diet and
            Weight Management are available for anyone over the age of 16.
          </p>

          <h4>
            When are the single session consultations not appropriate for Gut
            Health & Healthy Diet or Weight Management?
          </h4>
          <p>
            The single session consultations are here to provide personalised
            coaching, advice, and resources to help you effectively manage your
            weight, however, it is important to note the following exclusions:
          </p>
          <ul>
            <li>Eating Disorders such as Anorexia.</li>
            <li>Desire for Medication or Referral.</li>
            <li>Pregnant or Breastfeeding women.</li>
            <li>Children and Adolescents under the age of 16.</li>
            <li>Need for Clinical Diagnostics or Treatment</li>
          </ul>

          <h4>When are the consultations available to be booked?</h4>
          <p>
            Consultations are available Monday-Friday, 9am-5pm, excluding Public
            Holidays and Bank Holidays.
          </p>

          <h3 id="neurodiversity-service">3. Neurodiversity Service FAQs</h3>

          <h4>What service do you offer?</h4>
          <p>
            This service provides digital neurodiversity affirming autism, ADHD
            and combined AuDHD exploration and identification for adults and
            young people aged 7+, carried out remotely via video call. It’s
            available for policy holders and dependants named on the plan only.
          </p>
          <p>
            The assessments and appointments are conducted via secure video
            calls, providing you with a convenient and accessible option
            regardless of your location, with the initial consultation used to
            explain the process, agree hopes and goals, and advise on the best
            path forward for you or your dependants.
          </p>
          <p>
            A note on the term ‘assessment’: We recognise that terminology is
            ever evolving, and while the term ‘assessment’ has widely been used
            historically within the diagnostic process, we view the
            identification and diagnostic journey as a ‘collaborative
            exploration of identity and neurotype’ where you or your dependants
            work in partnership with professionals and will explore your unique
            narrative and experience.
          </p>

          <h4>Who provides the service?</h4>
          <p>Our neurodiversity team consists of:</p>
          <ul>
            <li>
              HCPC-registered Clinical psychologists with Chartered Psychologist
              status with the British Psychological Society (BPS) and Chartered
              Psychologist status with the Psychological Society of Ireland
              (PSI)
            </li>
            <li>
              HCPC-registered Speech and Language Therapists who are members of
              Royal College of Speech and Language Therapists (RCSLT), Irish
              Association of Speech & Language Therapists (IASLT)
            </li>
            <li>
              HCPC-registered Occupational Therapists who are members of the
              Royal College of Occupational Therapists (RCOT) and the
              Association of Occupational Therapists in Ireland (AOTI)
            </li>
          </ul>
          <p>
            All our practitioners are trained and highly experienced in using
            both standardised and neurodiversity-affirming assessment tools and
            models to inform their practice.
          </p>

          <h4>
            Who needs to be involved in my identity exploration (assessment)
            journey?
          </h4>
          <ul>
            <li>
              For young people aged 7+:
              <ol>
                <li>
                  The young person who would like to explore their identity and
                  neurotype
                </li>
                <li>Parent(s)/ Legal Guardian(s) of the young person</li>
                <li>
                  Information gathered from the young person’s education setting
                  via a questionnaire.
                </li>
                <li>
                  A team of specialist neurodiversity clinicians (Clinical
                  psychologist/ Speech and Language Therapist/Occupational
                  Therapist)
                </li>
              </ol>
            </li>
            <li>
              For Adults:
              <ol>
                <li>
                  The individual seeking to explore their identity and neurotype
                </li>
                <li>
                  An informant (someone that knows you well and can add valuable
                  information from their perspective) to complete a
                  questionnaire that will be considered as part of your identity
                  exploration.
                </li>
                <li>
                  A team of specialist neurodiversity clinicians (Clinical
                  Psychologist/ Speech and Language Therapist/Occupational
                  Therapist)
                </li>
              </ol>
            </li>
          </ul>

          <h4>How do I book a neurodiversity consultation?</h4>
          <p>
            You can book and pay for your assessment, with our partner
            Spectrum.life via the Simplyhealth app, SimplyPlan, or portal. Once
            you’ve logged in, just navigate to the General Health category
            within the ‘My Health’ tab to locate the service and select it. When
            booking, you’ll be asked to provide some information around why you
            would like to access the service, along with information about your
            experiences that may align with ADHD or autism to give the clinician
            some insight before your consultation. It will take around 10-15
            minutes to complete the questions upon booking and then you can
            choose the date and time that best suits you for the consultation.
            From here, you need to log into your SimplyPlan app or online portal
            and navigate to ‘My Health’ at the scheduled time in order to attend
            your prebooked video consultation.
          </p>

          <h4>
            Do you have a medication pathway following ADHD identification
            within your service?
          </h4>
          <p>
            Our service offers information, assessment, and non-medicated
            guidance in respect of ADHD. We do not provide medical advice or
            medicated interventions in respect of ADHD. As we are not a medical
            provider, our service should not be considered a substitute for
            professional medical advice or ADHD medication. It is important to
            consult a qualified healthcare professional for any medical concerns
            and/or ADHD medication needs.
          </p>

          <h4>
            Does your service offer Specific Learning Difficulty Assessments?
          </h4>
          <p>
            Our neurodiversity service is designed for individuals interested in
            exploring potential neurodivergence, specifically through autism,
            ADHD, or combined autism/ADHD assessments.
          </p>
          <p>
            Currently, we do not offer assessments for other types of
            neurodivergence, such as those related to specific learning profiles
            (for example dyslexia, dyscalculia, dysgraphia) or
            movement/coordination profiles (e.g., dyspraxia).
          </p>

          <h4>
            Can I have a consultation before committing to a full
            neurodivergence assessment?
          </h4>
          <p>
            Yes. The first step is an invitation to an initial neurodiversity
            consultation where a collaborative decision will be made about
            whether our service can meet your needs and whether engaging in an
            assessment is the most beneficial next step for you or your child.
            This discussion and screening questionnaires will enable your
            clinician to decide if there are enough indicators of
            neurodivergence to warrant a full exploration. Within this initial
            consultation, you’ll also be introduced to the team’s approach and
            learn more about the process going forward.
          </p>

          <h4>Suitability for our service:</h4>
          <p>
            Guidelines to ensure that the service can effectively, holistically,
            and safely support clients are detailed in our agreement and
            informed consent documentation to follow.
          </p>

          <h4>
            How does your digital journey compare to an in-person assessment?
          </h4>
          <p>
            A digital assessment is remarkably similar to an in-person
            assessment and includes many of the same elements. The same amount
            of time is spent exploring your priorities, experiences, getting to
            know you or your child, and reviewing all the information in
            reaching a diagnostic outcome.
            <br>
            A digital assessment means that you
            can speak to us from your own home at a time that is convenient for
            you. It also minimises time taken off work and school to attend
            in-person assessments.
          </p>
          <p>
            Undertaking the assessment from a familiar place can be less anxiety
            provoking. Some people prefer or find it easier interacting
            digitally, meaning that we get to know more of ‘the real them.’
            <br>
            Offering appointments digitally also enables us to offer more
            appointments at more flexible times as we are not constrained to
            physical locations.
          </p>

          <h4>What are the costs involved?</h4>
          <ul>
            <li>Neurodiversity Initial Consultation (First step): £200</li>
          </ul>
          <p>
            Assessment pricing (additional cost on top of consultation fee):
          </p>
          <ul>
            <li>Online ADHD Assessment: £900</li>
            <li>Online Autism Assessment: £1550</li>
            <li>Combined Autism & ADHD Assessment: £1900</li>
          </ul>
          <p>
            These service costs cannot be claimed back through your Simplyhealth
            plan.
          </p>

          <h4>What is your ethos and your practice standards?</h4>
          <p>We are a Neurodiversity affirming service:</p>
          <ul>
            <li>
              Our team continually strives to embody and develop neuro-affirming
              practice. We oppose the assumption that there is one ‘standard’
              neurotype that exists and recognise that the population is
              neurodiverse. Neurotype (or brain type) variation is not only
              natural and inevitable but valuable (i.e. not a deficit). We
              recognise that the process of being neurodiversity affirming is an
              ongoing journey with no fixed end point, and one which requires
              constant action, learning, engagement, and commitment. We
              continually evaluate our practice through critical reflection and
              active seeking of feedback, and challenge neuro-normative thinking
              at every opportunity.
            </li>
          </ul>
          <p>
            You will only be seen by practitioners who are professionally
            regulated in their practice:
          </p>
          <ul>
            <li>
              All neurodiversity identity explorations, collaborative sessions,
              training and guidance, have been developed and are conducted by a
              multidisciplinary team of specialist neurodiversity professionals
              consisting of Clinical Psychologists, Speech and Language
              Therapists, and Occupational Therapists with decades of experience
              working in NHS, HSE, private and third sector contexts with
              neurodivergent individuals across the lifespan.
            </li>
          </ul>
          <p>
            We use holistic, neurodivergent-informed practices and tools to
            inform your identity exploration:
          </p>
          <ul>
            <li>
              To ensure that our practice is truly inclusive and
              anti-discriminatory, all areas of the client journey are
              undertaken with the knowledge/consideration that various groups of
              people have been historically (and continue to be)
              underrepresented in the neurodivergent population. Therefore,
              alongside standardised assessment tools and questionnaires,
              Spectrum.Life practitioners are highly adept at drawing on
              extensive professional experience, alongside drawing on
              neurodivergent-led research and autistic and ADHD lived experience
              (within the team and externally), to account for the diversity of
              neurodivergent experience whilst also adhering to NICE guidance.
              This ensures that all the ways in which neurodivergent experience
              can present are captured and considered.
            </li>
          </ul>
          <p>Identity exploration outcome shared on the same day:</p>
          <ul>
            <li>
              On the same day that you meet our professionals directly to
              explore your identity, a collaborative outcome session will be
              held with you to share the outcome.
            </li>
          </ul>
          <p>We provide bespoke post-identification collaboration:</p>
          <ul>
            <li>
              We recognise the importance of focusing on identifying neurotype,
              and we also understand that the journey does not end there.
              Therefore, as part of the client’s journey of exploring and
              identifying their neurotype, our team highly values providing
              bespoke post-identification collaboration with clients, in order
              to support the individual on their subsequent journey of exploring
              their neurodivergent identity.
            </li>
          </ul>
          <p>Our core principles include:</p>
          <ul>
            <li>
              Recognising the intersection of individuals holding multiple
              identities such as expressions of gender, sexual orientation,
              race, ethnicity, class, spirituality, education, age, ability,
              mobility, health status, worldview, and how these intersections
              shape experiences and can overlap to create discrimination or
              privilege.
            </li>
            <li>
              Honouring and valuing diversity in communication, interaction,
              thinking styles, sensory experience, and ways of being in the
              world.
            </li>
            <li>Listening to and prioritising lived experience.</li>
            <li>
              Validating all neurotypes and understanding that neurodiversity is
              a natural and important part of human experience.
            </li>
            <li>
              Fostering positive self-identity: supporting people to understand
              themselves and live happy, healthy, authentic, and meaningful
              lives.
            </li>
            <li>Promoting self-advocacy and equitable requirements.</li>
          </ul>

          <h4>Are there any exclusions to the neurodiversity services?</h4>
          <p>Yes, these are the exclusions to consider:</p>
          <ul>
            <li>
              Types of assessment: The neurodiversity service is not suitable
              for individuals aged 6 years and under seeking autism, ADHD or
              combined autism/ADHD assessments.
            </li>
            <li>
              Receptive language/understanding: The assessment processes are not
              suitable for individuals who cannot receive, interpret and form
              coherent understanding of information communicated by others
              through sentence level speech or other forms of sentence level
              communication (such as written text).
            </li>
            <li>
              Previous assessments: The service may not be suitable for
              individuals who are seeking a second opinion or a re-evaluation of
              an existing diagnosis of autism/ADHD. These requests may be
              considered on an individual basis considering factors such as
              reason and timing of request, alongside potential risks and
              benefits. This is to maintain an individual's safety alongside
              upholding the validity and integrity of the assessment process.
            </li>
            <li>
              Physical and mental health: This remote service operates
              independently of local health authorities, making it suitable for
              individuals with stable physical and mental health. Those whose
              mental or physical health is not stable would not be suitable, as
              general health, energy levels, mood and stress would impede
              cognitive functioning, and not allow for full engagement in the
              assessment process.
            </li>
          </ul>

          <h3 id="digital-therapy">
            4. Open-ended Digital Therapy Service FAQs
          </h3>

          <h4>What is the Open-ended Digital Therapy Service?</h4>
          <p>
            This service is a digital psychological therapy service for adults,
            children and young people aged 6 and above, who are experiencing
            mild to moderate emotional and/or behavioural difficulties. It’s
            suitable for anyone in need of therapy for difficulties that may be
            more chronic and complex in nature along with deep-rooted issues
            that require a longer length of therapy.
          </p>
          <p>
            Delivered through secure online platforms, it provides high quality,
            personalised and evidence-based care in a flexible and convenient
            way. The 50-minute sessions are delivered by highly trained
            psychologists or psychotherapists who use proven therapeutic
            techniques to foster long-lasting improvements in emotional
            wellbeing. The number of sessions is tailored to your specific
            needs, with plans agreed collaboratively between yourself and your
            therapist. For young people, parents or guardians are actively
            involved in the process to ensure the best possible outcomes.
          </p>

          <h4>What are the costs of these services?</h4>
          <ul>
            <li>Adult Psychology: £130</li>
            <li>Adult Psychotherapy: £89</li>
            <li>Child/Youth Psychology: £130</li>
            <li>Child/Youth Psychotherapy: £105</li>
          </ul>

          <h4>Who is the Digital Therapy Service for?</h4>
          <p>
            The Digital Therapy service is available to adults, children, and
            young people. We can support individuals seeking psychological
            support for mild to moderate mental health challenges, including
            anxiety, low mood, OCD, trauma, low self-esteem and confidence. A
            variety of therapeutic approaches are offered. Depending on the
            presenting need, we may offer goal-led interventions or more
            structured psychological therapies.
          </p>
          <p>
            For children and young people (aged 6-17) experiencing emotional
            and/or behavioural difficulties, we can support individuals and
            parents/carers, including parent coaching, psychoeducation and
            support for their own wellbeing.
          </p>

          <h4>
            What process should I follow to get an appointment and how long will
            it take?
          </h4>
          <p>
            You can log into your Simplyhealth app or portal and explore the
            different services that are available. When you are ready, you can
            book a session that feels right for you. If you’re unsure which
            clinical pathway is best for you and your needs, we recommend
            starting with a session with one of our Psychotherapists. They can
            support you, and by discussing your concerns, they can guide you
            toward the most appropriate care pathway.
            <br>
            Sessions are available
            within a 5-day booking period, or you can choose a later date if
            that works better for your schedule.
          </p>

          <h4>How can I book open-ended digital therapy?</h4>
          <p>
            You can log into your Simplyhealth app, SimplyPlan, or online portal
            and navigate to the Mental Health category within ‘My Health’ to
            locate the service, book and make your payment directly to our
            partner, Spectrum.life. Sessions are available within a 5-day
            booking period, but you can choose a later date if that’s preferable
            for your schedule. To book further sessions, just discuss
            availability with your therapist and they’ll advise you on the days
            and times they’re free. You can then log into your Simplyhealth app
            or online portal, navigate to the Mental Health category within ‘My
            Health’ and follow the flow as per your initial booking, selecting
            the availability discussed and booking your session, choosing the
            same clinician.
          </p>

          <h4>
            Are there any exclusions to the open-ended digital therapy service?
          </h4>
          <p>
            These services are designed to support those experiencing mental
            health difficulties with mild to moderate impact on their wellbeing,
            however we kindly request that you consider the following potential
            exclusion criteria:
          </p>
          <ul>
            <li>Must not have a plan and/or intent to commit suicide</li>
            <li>No attempts made to end life within the last 12 months</li>
            <li>
              Must not be frequently self-harming in a way that requires medical attention
            </li>
            <li>Must not have current alcohol or drug dependency</li>
            <li>
              Must not be acutely unwell/distressed to the extent that you
              cannot participate in psychological intervention
            </li>
            <li>
              If acute psychosis or an eating disorder is the primary need, the
              service may not be appropriate
            </li>
            <li>
              Must not have concerns about the individual (yourself or your
              child/dependant) that requires a physical/face-to-face assessment
            </li>
            <li>
              Must not be in a situation that is psychologically unsafe, for
              example current domestic violence or intimate partner abuse
            </li>
            <li>
              Must not be involved in an active criminal investigation or
              currently on a child protection plan
            </li>
            <li>
              Additional learning or support needs that affect participation in
              psychological intervention
            </li>
          </ul>

          <h4>What age range of children is the service appropriate for?</h4>
          <p>
            We can work with children from the age of 6 years. From this age,
            children may start to develop insight into their own feelings,
            thoughts, and the impact of their behaviour. We can start to
            collaborate with them and their parents, recognising that we may be
            working on more behavioural aspects while their insight develops
            further.
          </p>

          <h4>
            What if the individual/young person/child would be more suited to an
            in-person service? Are there support services they can be
            referred into?
          </h4>
          <p>
            All services are offered digitally. If we have concerns about harm
            coming to someone and therefore sessions cannot be conducted online
            safely, or if there are current safeguarding proceedings and/or
            police investigations, we would not advise remote sessions. The
            clinician will of course discuss with the family where appropriate
            support could come from to meet their needs, and how to access this.
          </p>

          <h4>What information gets shared back and to whom?</h4>
          <p>
            Following the end of therapy, individuals will receive
            correspondence summarising the intervention. This is shared with the
            individual, who is free to share the correspondence with whomever
            they wish. If we think it could be helpful to share information with
            any other professionals or services, we will of course discuss this
            with the individual- what it looks like and what to share. This will
            be discussed and agreed with everyone on a case-by-case basis.
          </p>
          <p>
            We respect privacy and will share solely what we get consent to
            share. Clinicians will discuss with children what they wish to share
            with parents, and how they would like to do so. However, if we think
            someone is at risk of harm, then we have a duty of care to share
            information and we may breach confidentiality, as we want to ensure
            that everyone is safe. We will always do our best to keep you
            informed if this is the case.
          </p>
          <h4>
            Is the information I share with you about me/my child safe?
          </h4>
          <p>
            Spectrum.Life is a strategic partner of Simplyhealth and adheres to
            our stringent third-party control protocols. Spectrum.Life are
            dedicated to protecting the data of our members and maintain a
            complex ISMS program managed by a dedicated security and privacy
            team. All client data is stored in highly secure MSP data centers
            within the EEA. Spectrum.Life are fully ISO-27001 and IASME Cyber
            Essentials certified.
          </p>
        </div>
      </div>
      <Footer
        v-if="$store.state.user.authenticated"
        :isLightTheme="true"
      ></Footer>
    </div>
  </div>
</template>

<script>
import Footer from "../components/Footer";

export default {
  name: "SpectrumFAQs",
  components: {
    Footer
  }
};
</script>

<style lang="less">
#SpectrumFAQs {
  .main {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .page-header {
    padding: 60px 20px 20px;
    background-color: #fbfafa;
  }

  .logo {
    max-width: 350px;
    width: 100%;
    padding-bottom: 50px;
  }

  .page-title {
    h2 {
      text-align: center;
      font-size: 3.8rem;
      letter-spacing: normal;
      font-family: "PlusJakartaSansBold";
    }
  }

  .content {
    flex: 1 1 100%;
    padding: 20px 20px 60px;
    background-color: #fbfafa;
  }

  .content-card {
    height: 100%;
    background: #ffffff;
    max-width: 1000px;
    padding: 40px 60px 30px;
    margin: 0 auto;
    border-radius: 16px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: #212529;
      font-family: "PlusJakartaSansBold";
    }

    h3 {
      font-size: 2.2rem;
      letter-spacing: 0;
      padding: 32px 0 0;
      margin: 0 0 24px;
    }

    h4 {
      font-size: 1.6rem;
      letter-spacing: 0;
      padding: 0;
      margin: 0 0 4px;
    }

    p {
      color: #212529;
      padding: 0;
      margin: 0 0 16px;
      font-size: 1.6rem;
    }

    ul,
    ol {
      color: #212529;
      margin: 0 0 16px;
    }

    li {
      color: #212529;
      font-size: 1.6rem;
    }

    .top-list {
      li {
        margin-bottom: 6px;
      }

      a {
        color: #3c16f9;

        &:hover,
        &:active {
          color: #3c16f9;
        }
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .content-card {
      padding: 30px 20px;
    }
  }
}
</style>
